import { useEffect, useState } from 'react';
import ClientService from '../../../repository/clientRepository/ClientRepository';
import ClientTerm from './ClientTerm';
import AddEditClientModal from './AddEditClientModal';
import '../../../App.css';
import Swal from 'sweetalert2';
import '../../../localization/Localization';
import { strings } from '../../../localization/Localization';
import { useAuth } from '../../Auth/AuthContext';
import ClientOnExcursionService from '../../../repository/clientOnExcursionRepository/ClientOnExcursionRepository';

const Clients = () => {
  const [clients, setClients] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [input, setInput] = useState('');
  const [sortField, setSortField] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const { isAdmin } = useAuth();

  useEffect(() => {
    getClients();
  }, [page, sortField, sortOrder, pageSize]);

  const getClients = () => {
    ClientService.getAllClients(page, pageSize, sortField, sortOrder, input)
      .then((data) => {
        setClients(data.data.content);
        setTotalPages(data.data.totalPages);
      })
      .catch((error) => {
        console.error('Error fetching clients:', error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    getClients();
  };

  const handleSortSubmit = (e) => {
    e.preventDefault();
    getClients();
  };

  const handleSortFieldChange = (e) => {
    setSortField(e.target.value);
  };

  const handleSortOrderChange = (e) => {
    setSortOrder(e.target.value);
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value) || 5;
    setPageSize(newSize);
    setPage(0);
  };

  const handleExport = () => {
    ClientService.exportClients()
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'clients.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        Swal.fire({
          icon: 'success',
          title: strings.exportSuccessful,
        });
      })
      .catch((error) => {
        console.error('Error exporting clients:', error);
        Swal.fire({
          icon: 'error',
          title: strings.exportFailed,
          text: strings.failedToExport
        });
      });
  };

  const handleFullExport = () => {
    ClientOnExcursionService.fullExport()
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'client-excursions.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        Swal.fire({
          icon: 'success',
          title: strings.exportSuccessful,
        });
      })
      .catch((error) => {
        console.error('Error exporting client excursions:', error);
        Swal.fire({
          icon: 'error',
          title: strings.exportFailed,
          text: strings.failedToExport
        });
      })
  };

  return (
    <div className={'container mt-3'}>
      <AddEditClientModal
        showModal={showAddModal}
        handleClose={() => setShowAddModal(false)}
        getClients={getClients}
      />
      <h2 className={'text-center mt-4'}>{strings.clients}</h2>
      <hr className={'mt-0'}/>
      <div className={'d-flex flex-wrap'}>
        <div className={'mt-3 me-4'}>
          <form className='d-flex form-inline my-2 my-lg-0' onSubmit={handleSubmit}>
            <input
              className='form-control mr-sm-2'
              type='search'
              placeholder='Search'
              aria-label='Search'
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            <button className='btn btn-outline-secondary my-2 my-sm-0' type='submit'>
              {strings.search}
            </button>
          </form>
        </div>
        <div className={'mt-3'}>
          <form className='d-flex form-inline my-2 my-lg-0' onSubmit={handleSortSubmit}>
            <div className='position-relative mr-2'>
              <select
                className='form-control custom-select mr-2'
                value={sortField}
                onChange={handleSortFieldChange}
              >
                <option value='name'>{strings.name}</option>
                <option value='surname'>{strings.surname}</option>
                <option value='points'>{strings.points}</option>
              </select>
            </div>
            <div className='position-relative mr-2'>
              <select
                className='form-control custom-select mr-2'
                value={sortOrder}
                onChange={handleSortOrderChange}
              >
                <option value='asc'>{strings.ascending}</option>
                <option value='dsc'>{strings.descending}</option>
              </select>
            </div>
            <button className='btn btn-outline-secondary my-2 my-sm-0' type='submit'>
              {strings.sort}
            </button>
          </form>
        </div>
        <div className={"ms-4 mt-3 d-flex"}>
          <span className={"text-secondary mt-1"}>{strings.paginationSize}</span>
          <input
            className='form-control mx-2'
            type='number'
            min='1'
            placeholder='Page Size'
            value={pageSize}
            onChange={handlePageSizeChange}
            style={{ width: '70px' }}
          />
        </div>
        <div className={'ms-auto d-flex'}>
          {isAdmin && (
            <>
              <button
                className={'d-flex ms-auto mt-3 me-2 btn btn-danger px-3 rounded-4'}
                onClick={handleExport}
              >
                {strings.export}
              </button>
              <button
                className={'d-flex ms-auto mt-3 me-2 btn btn-danger px-3 rounded-4'}
                onClick={handleFullExport}
              >
                {strings.fullExport}
              </button>
            </>
          )}
          <button
            className={'d-flex ms-auto mt-3 btn btn-primary px-3 rounded-4'}
            onClick={() => setShowAddModal(true)}
          >
            {strings.addNewClient}
          </button>
        </div>
      </div>
      <table className={'table user-table table-responsive table-borderless table-striped mb-1 mt-3'}>
        <thead className={'table-header-css'}>
        <tr className={'rounded-4'}>
          {['', strings.name, strings.surname, strings.dateOfBirth, strings.phoneNumber, strings.email, strings.points, strings.loyaltyStatus, strings.address].map((column) => (
            <th key={column}>{column}</th>
          ))}
          <th>{strings.actions}</th>
        </tr>
        </thead>
        <tbody>
        {clients.length > 0 ? (
          clients.map((client, index) => (
            <ClientTerm
              client={client}
              key={index}
              getClients={getClients}
              handleClose={() => setShowAddModal(false)}
              showModal={showAddModal}
            />
          ))
        ) : (
          <tr>
            <td colSpan='12' className={'text-center my-5'}>
              <i className={'text-secondary no-notification-message'}>{strings.noClients}</i>
            </td>
          </tr>
        )}
        </tbody>
      </table>
      <div className='my-2 d-flex justify-content-center gap-2'>
        <button
          disabled={page === 0}
          onClick={() => setPage(page - 1)}
          className={`px-3 py-2 rounded font-bold transition ${
            page === 0 ? 'bg-light-gray color-dark-blue cursor-not-allowed' : 'bg-dark-blue text-white hover:opacity-80'
          }`}
        >
          ← {strings.previous}
        </button>
        <span className='color-dark-blue font-bold mt-2'>
          {strings.page} {page + 1} {strings.of} {totalPages}
        </span>
        <button
          disabled={page + 1 >= totalPages}
          onClick={() => setPage(page + 1)}
          className={`px-3 py-2 rounded font-bold transition ${
            page + 1 >= totalPages ? 'bg-light-gray color-dark-blue cursor-not-allowed' : 'bg-dark-blue text-white hover:opacity-80'
          }`}
        >
          {strings.next} →
        </button>
      </div>
    </div>
  );
};

export default Clients;